import { render, staticRenderFns } from "./SummaryFooter.vue?vue&type=template&id=790f962d&"
import script from "./SummaryFooter.vue?vue&type=script&lang=js&"
export * from "./SummaryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports